
import { Link } from 'react-router-dom';

const CreditApplicationNotEligible = () => {
    return (
        <div className="flex justify-center items-center">
          <div className="relative w-[559px] bg-[#FFFFFF] h-full p-[20px] rounded-lg justify-center items-center">
            <p className="font-aeonik text-center text-2xl font-bold leading-7 my-4">
                Your business is not eligible for an Earnipay Loan at this time
            </p>
            <p className="font-thin text-center text-[16px] text-[#4A5564] my-8">
                Your application has not met our requirements for a loan offer. You can re-apply for a loan in 6 days
            </p>
            <p className="font-thin text-center text-[16px] text-[#4A5564]">
                If you think this was a mistake or have some more information to provide, kindly send an email with the information to business@earnipay.com         
            </p>
            <div className="mt-[56px] flex w-full">
            <Link to="/credit" loading={false} className="btn h-[56px] w-full btn-ep-primary">
                Re-Apply
            </Link>
            </div>
          </div>
        </div>
      )
}

export default CreditApplicationNotEligible;